import defaultColors from './colors';

const colors = {
  ...defaultColors,

  primary: defaultColors.blue,
  primaryDark: defaultColors.blueDark,
  font: '#a8b5d0',
  fontDark: '#516785',
  background: '#1b212c',
  mainBackground: '#212835',
  border: defaultColors.black,
  hover: defaultColors.orange,
  shadow: defaultColors.black,
};

export default {
  colors: colors,
};
